import React from 'react';

/**
 * Wrapper for an admin panel section. Provides consistent header + body layout.
 */
const AdminSection = ({ title, subtitle, ownerOnly, role, children }) => {
  if (ownerOnly && role !== 'owner') return null;
  return (
    <div className="card admin-card">
      <div className="admin-card-head">
        <div>
          <div className="card-title" style={{ marginBottom: 4 }}>{title}</div>
          {subtitle && <div className="card-sub">{subtitle}</div>}
        </div>
        {ownerOnly && <span className="badge badge-yellow">OWNER ONLY</span>}
      </div>
      <div className="admin-card-body">{children}</div>
    </div>
  );
};

export default AdminSection;
